var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[(_vm.currentProduct)?_c('product-detail',{attrs:{"product":_vm.currentProduct}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }